<template>
  <el-dialog
    class="dialog"
    :title="title"
    :visible.sync="visible"
    :show-close="showClose"
    :width="width"
  >
    <div class="dialog-body" :style="{ maxHeight: maxHeight + 'px' }">
      <slot></slot>
    </div>
    <template v-slot:footer>
      <el-button @click="visible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: "Dialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "标题",
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    maxHeight: {
      type: Number,
      default: 320,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.visible = newValue;
      },
    },
    visible(newValue) {
      this.$emit("change", newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  /deep/ {
    .el-dialog__header {
      text-align: center;
      padding: 20px 0;
    }
    .el-dialog__title {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      line-height: 24px;
      display: block;
    }
    .el-dialog__body {
      padding: 0 24px;
      color: #333;
    }
    .el-dialog__footer {
      padding: 24px;

      .el-button {
        height: 36px;
        border: 1px solid #bfbfbf;
        border-radius: 5px;
        line-height: 36px;
        padding: 0 20px;

        &:hover {
          border-color: $primary-color-light;
        }
      }
    }
  }
}
.dialog-body {
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    width: 6px;
    background: #bfbfbf;
    border-radius: 3px;
  }
}
</style>
